import React, { useState } from 'react'
import { Box, Button, FormControl, FormControlLabel, Input, InputLabel, Modal, Switch } from '@mui/material'
import ShireImageUpload from 'components/ShireImageUpload'
import { BannerType, CreateBannerRequest } from './BannerType'
import { uploadImage } from 'services/FileService'
import { createBanner } from 'services/BannerService'
import { publishMessage } from 'components/ShireMessage'

type BannerModalProps = {
  open: boolean,
  onClose: () => void,
  handlePostCreate: () => void,
  bannerType: BannerType
}

export default function BannerModal({
  open, onClose, handlePostCreate, bannerType
}: BannerModalProps) {
  const [imageFile, setImageFile] = useState<File | null>(null);
  const [banner, setBanner] = useState<CreateBannerRequest>({
    title: "",
    description: "",
    imageUrl: "",
    externalId: "",
    isActive: false,
    bannerTypeId: bannerType.id
  })

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    
    if (!imageFile) {
      publishMessage({
        message: "Please upload an image",
        variant: "warning",
      });
      return
    }

    const formData = new FormData()
    formData.append("image", imageFile)
    const { url, public_id: publicId } = await uploadImage(formData, 'banners')
    
    const bannerRequest: CreateBannerRequest = {
      title: banner.title,
      description: banner.description,
      imageUrl: url,
      externalId: publicId,
      isActive: banner.isActive,
      bannerTypeId: bannerType.id
    }

    const response = await createBanner(bannerRequest)

    handlePostCreate();
  }

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        component="form"
        sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 800, bgcolor: 'background.paper', boxShadow: 24, p: 4 }}
        onSubmit={onSubmit}
      >
        <h2>Create Banner</h2>
        <ShireImageUpload
          file={imageFile}
          setFile={setImageFile}
          minWidth={bannerType.minWidth}
          minHeight={bannerType.minHeight}
          maxWidth={bannerType.maxWidth}
          maxHeight={bannerType.maxHeight}
          label="Upload Banner Image"
          accept="image/jpeg,image/png,image/webp,image/jpg"
        />

        <FormControl fullWidth sx={{ marginTop: 2 }}>
          <InputLabel id="demo-simple-select-label">Title</InputLabel>
          <Input
            value={banner.title}
            onChange={(e) => setBanner({ ...banner, title: e.target.value })}
          />
        </FormControl>

        <FormControl fullWidth sx={{ marginTop: 2 }}>
          <InputLabel id="demo-simple-select-label">Description</InputLabel>
          <Input
            value={banner.description}
            multiline
            maxRows={3}
            onChange={(e) => setBanner({ ...banner, description: e.target.value })}
          />
        </FormControl>

        <FormControlLabel
            sx={{ marginTop: 2}}
            control={
              <Switch
                checked={banner.isActive}
                onChange={(e) => setBanner((prev) => ({ ...banner, isActive: !prev.isActive }))}
                color="primary"
              />
            }
            label={banner.isActive ? 'Active' : 'Inactive'}
            labelPlacement="start"
          />

          <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: 5 }}>
            <Button type='submit' variant="contained" color="primary">
              Add Banner
            </Button> 
          </Box>

      </Box>
    </Modal>
  )
}
